import Vue from 'vue';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';

Vue.use(ConfirmationService);
Vue.component('ConfirmPopup', ConfirmPopup);
